import React from "react"
import { Modal as AntModal } from "antd"
import PropTypes from "prop-types"
import { PrimeButton } from "components-design-system"

// assets
import confirmImg from "assets/images/modal-confirm.png"
import createImg from "assets/images/modal-create.png"
import createSmImg from "assets/images/modal-create-sm.png"
import editImg from "assets/images/modal-edit.png"
import readOnlyImg from "assets/images/modal-read-only.png"
import reviewImg from "assets/images/modal-review.jpg"
import deleteImg from "assets/images/modal-delete.png"
import deleteAltImg from "assets/images/modal-delete-alt.png"
import reminderImg from "assets/images/reminder.png"
import "./Modal.scss"

export const ModalFooter = ({
  type,
  cancelText,
  onCancel,
  cancelButtonProps,
  onOkText,
  onOk,
  okButtonProps,
  disabled,
  htmlType,
  size = "large",
  confirmLoading,
}) => {
  return [
    <PrimeButton
      key="cancel-btn"
      size={size}
      onClick={onCancel}
      disabled={confirmLoading}
      {...cancelButtonProps}
      className="close-btn"
    >
      {cancelText ? cancelText : "Cancel"}
    </PrimeButton>,
    <PrimeButton
      key="ok-btn"
      type="primary"
      size={size}
      onClick={onOk}
      danger={type === "delete"}
      {...okButtonProps}
      htmlType={htmlType}
      disabled={disabled}
      className="ok-btn"
      loading={confirmLoading}
    >
      {onOkText()}
    </PrimeButton>,
  ]
}

const Modal = ({
  type,
  message,
  disabled = false,
  hideImage,
  imgSrc,
  children,

  // antd Modal props:
  title,
  subTitle,
  open = false,
  visible = false, // depracated for prop "open"
  cancelText,
  onCancel,
  cancelButtonProps,
  okText,
  onOk,
  okButtonProps,
  footer,
  width = 366,
  className,
  destroyOnClose = true,
  confirmLoading,
  ...moreProps // onChange (value, options)
}) => {
  const modalImage = () => {
    if (!type) return null
    let img = confirmImg
    if (imgSrc) {
      img = imgSrc
    } else if (type === "create") {
      img = createImg
    } else if (type === "create-sm") {
      img = createSmImg
    } else if (type === "edit") {
      img = editImg
    } else if (type === "read-only") {
      img = readOnlyImg
    } else if (type === "review") {
      img = reviewImg
    } else if (type === "delete") {
      img = deleteImg
    } else if (type === "delete-alt") {
      img = deleteAltImg
    } else if (type === "bell") {
      img = reminderImg
    }
    return (
      <img
        src={img}
        alt={title}
        className={`modal-image ${type}-modal`}
      />
    )
  }

  const onOkText = () => {
    if (okText) {
      return okText
    } else if (type === "delete") {
      return "Delete"
    } else if (type === "create") {
      return "Save"
    } else {
      return "Submit"
    }
  }

  const getWidth = () => {
    if (width) return width
    if (type === "delete") {
      return 310
    }
  }

  let antFooter = (
    <ModalFooter
      type={type}
      cancelText={cancelText}
      onCancel={onCancel}
      onOkText={onOkText}
      onOk={onOk}
      disabled={disabled}
      cancelButtonProps={cancelButtonProps}
      okButtonProps={okButtonProps}
      confirmLoading={confirmLoading}
    />
  )

  if (footer || footer === null) {
    antFooter = footer
  }

  let classNames = ["prime-modal"]

  if (type) {
    classNames.push(type)
  } else {
    classNames.push("no-type")
  }
  if (className) classNames.push(className)
  if (footer?.length === 0) classNames.push("no-modal-footer")
  if (type === "create-sm") classNames.push("is-image-small")

  return (
    <AntModal
      title={null}
      subTitle={null}
      open={open || visible}
      onCancel={onCancel}
      footer={antFooter}
      width={getWidth()}
      className={classNames.join(" ")}
      destroyOnClose={destroyOnClose}
      {...moreProps}
    >
      <div className="modal-header">
        {hideImage !== true && modalImage()}
        {title && <div className="prime-modal-title">{title}</div>}
        {subTitle && <div className="prime-modal-subtitle">{subTitle}</div>}
      </div>
      {message && <div className="modal-message">{message}</div>}
      {children}
    </AntModal>
  )
}

Modal.propTypes = {
  type: PropTypes.oneOf([
    "confirm",
    "delete",
    "delete-alt",
    "create",
    "create-sm",
    "edit",
    "review",
    "bell",
    "read-only",
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.node,
  open: PropTypes.bool,
  visible: PropTypes.bool,
  cancelText: PropTypes.node,
  onCancel: PropTypes.func,
  okText: PropTypes.node,
  onOk: PropTypes.func,
  disabled: PropTypes.bool,
  hideImage: PropTypes.bool,
  children: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.oneOfType([
    PropTypes.number, // 90
    PropTypes.string, // "90vw"
  ]),
  className: PropTypes.string,
}

export default Modal
